import { useEffect, useState } from "react";
import HomeStoreComponent from "../../components/homeStore";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { getHomeStoreServiceApi } from "../../services/homeStore.service";
import { useParams } from "react-router-dom";

const HomeStore = () => {
  const [response, setResponse] = useState<any>();
  const dispatch = useAppDispatch();
  const params = useParams();
  const id = params?.id;

  useEffect(() => {
    dispatch(
      getHomeStoreServiceApi({
        data: id,
        finalCallback: () => {
        },
        successCallback: (data?: any) => {
          setResponse(data);
          localStorage.setItem("user_name", data?.data?.customer_name);
          localStorage.setItem("user_email", data?.data?.customer_email);
          localStorage.setItem("survey_id", data?.data?.survey_id);
        },
      })
    );
  }, []);
  return <HomeStoreComponent data={response?.data} />;
};

export default HomeStore;
